// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wdij","badges":"styles_badges__1IEOA"};